export const FEEDBACKS = {
  ADD: 'ADD_FEEDBACK',
  GET_LIST: 'GET_FEEDBACKS_LIST',
}
